<template>
  <div class="applicant-filter" layout>
    <div class="mr-x1">
      <el-button class="el-button-mt" type="default" @click="onChangeBackEvent"
        ><i class="mdi mdi-arrow-left"></i>戻る</el-button
      >
    </div>
    <select-form
      :label="isFollowing.label"
      :icon="isFollowing.icon"
      :value="isFollowing.value"
      :options="isFollowing.options"
      :onChange="onChangeIsFollowing"
      :size="isFollowing.size"
      clearable
    ></select-form>
    <select-form
      :label="isCandidate.label"
      :icon="isCandidate.icon"
      :value="isCandidate.value"
      :options="isCandidate.options"
      :onChange="onChangeIsCandidate"
      :size="isCandidate.size"
      clearable
    ></select-form>
    <select-form
      :label="isWinner.label"
      :icon="isWinner.icon"
      :value="isWinner.value"
      :options="isWinner.options"
      :onChange="onChangeIsWinner"
      :size="isWinner.size"
      clearable
    ></select-form>
    <select-form
      :label="isResponder.label"
      :icon="isResponder.icon"
      :value="isResponder.value"
      :options="isResponder.options"
      :onChange="onChangeIsResponder"
      :size="isResponder.size"
      clearable
    ></select-form>
    <div class="advance-filter-show" @click="toggleShowAdvanceFilter">
      <template v-if="!showAdvanceFilter">
        <span>詳細検索&nbsp;</span>
        <i class="mdi mdi-arrow-down-drop-circle-outline" />
      </template>
      <template v-else>
        <span>詳細検索を終了&nbsp;</span>
        <i class="mdi mdi-arrow-up-drop-circle-outline" />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './applicant_filter';
</style>

<style lang="scss">
@use '@/client/assets/scss/variables.scss' as *;

.applicant-filter {
  .el-input__inner {
    height: $spacing-unit * 4;
  }

  .el-input {
    width: $spacing-unit * 18;
  }
}
</style>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import SelectForm from '@/client/components/_atoms/select_form'
import { TrackingService } from '@/client/services'
import { useInstagramApplicantStore } from '@/client/store/useInstagramApplicantStore'

export default defineComponent({
  components: {
    SelectForm
  },
  data() {
    return {
      // フォロー
      isFollowing: {
        value: '' as '' | number,
        label: 'フォロー',
        icon: 'check-circle',
        size: 'small',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: 'フォローあり',
            value: 1
          },
          {
            label: 'フォローなし',
            value: 0
          }
        ]
      },
      // 当選者
      isWinner: {
        value: '' as '' | number,
        label: '当選者',
        icon: 'trophy',
        size: 'small',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '当選フラグあり',
            value: 1
          },
          {
            label: '当選フラグなし',
            value: 0
          }
        ]
      },
      // 回答者
      isResponder: {
        value: '' as '' | number,
        label: '回答者',
        icon: 'clipboard-check',
        size: 'small',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '回答フラグあり',
            value: 1
          },
          {
            label: '回答フラグなし',
            value: 0
          }
        ]
      },
      // 候補者
      isCandidate: {
        value: '' as '' | number,
        label: '候補者',
        icon: 'star',
        size: 'small',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '候補者フラグあり',
            value: 1
          },
          {
            label: '候補者フラグなし',
            value: 0
          }
        ]
      }
    }
  },
  computed: {
    ...mapState(useInstagramApplicantStore, {
      showAdvanceFilter: state => state.showAdvanceFilter,
      params: state => state.params,
      campaign: state => {
        if (state.campaign) {
          return state.campaign
        }
        return {}
      }
    })
  },
  methods: {
    ...mapActions(useInstagramApplicantStore, ['toggleShowAdvanceFilter', 'setParams', 'fetchApplicants']),

    onChangeIsFollowing(value: number) {
      TrackingService.sendEvent('select:応募一覧（IG）|フォロー')

      this.isFollowing.value = value
      if (this.params.isFollowing === value) {
        return
      }
      this.setParams({ isFollowing: value })
      this.fetchApplicants()
    },

    onChangeIsWinner(value: number) {
      TrackingService.sendEvent('select:応募一覧（IG）|当選者')

      this.isWinner.value = value
      if (this.params.isWinner === value) {
        return
      }
      this.setParams({ isWinner: value })
      this.fetchApplicants()
    },

    onChangeIsResponder(value: number) {
      TrackingService.sendEvent('select:応募一覧（IG）|回答者')

      this.isResponder.value = value
      if (this.params.isResponder === value) {
        return
      }
      this.setParams({ isResponder: value })
      this.fetchApplicants()
    },

    onChangeIsCandidate(value: number) {
      TrackingService.sendEvent('select:応募一覧（IG）|候補者')

      this.isCandidate.value = value
      if (this.params.isCandidate === value) {
        return
      }
      this.setParams({ isCandidate: value })
      this.fetchApplicants()
    },

    onChangeBackEvent() {
      TrackingService.sendEvent('click:応募一覧（X）|戻る')

      this.$router.push('/instagram_campaigns/' + this.$route.params.campaignId + '/prizes')
    }
  }
})
</script>
